import { atom } from 'recoil'
import { IDashboard } from './dashboards.types'

export interface IDashboardsAtomState {
  items: IDashboard[]
  filters: {
    type: 'personal' | 'shared'
    search: string
  }
}

const dashboardsAtom = atom<IDashboardsAtomState>({
  key: 'dashboards',
  default: {
    items: [],
    filters: {
      type: 'personal',
      search: '',
    },
  },
})

export default dashboardsAtom
